if ( typeof ProductImageZoom !== 'function' ) {
	class ProductImageZoom extends HTMLElement {

		constructor(){

			super();

			if ( ! document.getElementById('zoom') ) {
				this.zoom = document.createElement('div');
				this.zoom.id = 'zoom';
				this.zoom.innerHTML = `
					<img />
					<span class="zoom__exit">${KROWN.settings.symbols.zoom_out}</span>
					<span class="zoom__loader">${KROWN.settings.symbols.zoom_loader}</span>
					<div class="zoom__overlay"></div>
				`;
				document.body.append(this.zoom);
				this.zoom.querySelector('.zoom__exit').addEventListener('click', this._productZoomUnmount.bind(this));
			} else {
				this.zoom = document.getElementById('zoom');
			}

		this.onMouseMoveHandlerBinded = this.onMouseMoveHandler.bind(this);
		this.onResizeHandlerBinded = this.onResizeHandler.bind(this);
		this.onEscapeKeyBinded = this.onEscapeKey.bind(this);

		this.addEventListener('click', (e)=>{
				this.zoom.classList.add('opened');
				this.image = this.zoom.querySelector('img');
				this.image.src = this.getAttribute('data-image');
				if ( this.image.naturalWidth > 0 ) {
					this._productZoomMount();
				} else {
					this.image.addEventListener('load', this._productZoomMount.bind(this));
				}
			});

		}

	onMouseMoveHandler(e){
		if (window.innerWidth <= 768) {
			window.clientX = e.clientX;
			window.clientY = e.clientY;
			const x = e.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = e.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}
	}	onResizeHandler(){

		const rf = window.innerWidth > 768 ? 0.8 : 2;
		const maxWidth = window.innerWidth;
		const maxHeight = window.innerHeight;

		if ( this.image.classList.contains('portrait') ) {
			let width = window.innerWidth*rf;
			let height = window.innerWidth*rf / this.image.dataset.ratio;
			
			if (window.innerWidth <= 768) {
				width = Math.min(width, maxWidth);
				height = Math.min(height, maxHeight);
			}
			
			this.image.style.width = width + 'px';
			this.image.style.height = height + 'px';
		} else {

			let height = window.innerHeight*rf;
			let width = window.innerHeight*rf * this.image.dataset.ratio;

			if ( this.image.offsetWidth < window.innerWidth ) {
				width = window.innerWidth*rf;
				height = window.innerWidth*rf / this.image.dataset.ratio;
			}
			
			if (window.innerWidth <= 768) {
				width = Math.min(width, maxWidth);
				height = Math.min(height, maxHeight);
			}

			this.image.style.width = width + 'px';
			this.image.style.height = height + 'px';

		}

		if (window.innerWidth > 768) {
			const centerX = (window.innerWidth - this.image.offsetWidth) / 2;
			const centerY = (window.innerHeight - this.image.offsetHeight) / 2;
			this.image.style.left = centerX + 'px';
			this.image.style.top = centerY + 'px';
		} else {
			const x = window.clientX * ( window.innerWidth - this.image.offsetWidth ) / window.innerWidth;
			const y = window.clientY * ( window.innerHeight - this.image.offsetHeight ) / window.innerHeight;
			this.image.style.left = x + 'px';
			this.image.style.top = y + 'px';
		}

	}

	onEscapeKey(e){
		if (e.keyCode === window.KEYCODES.ESC && this.zoom.classList.contains('opened')) {
			this._productZoomUnmount();
		}
	}

	_productZoomMount(image) {

			this.image.style.left = 0;
			this.image.style.top = 0;
			this.image.style.objectFit = 'contain';

		window.addEventListener('mousemove', this.onMouseMoveHandlerBinded, {passive:true});

		this.image.dataset.ratio = this.image.naturalWidth / this.image.naturalHeight;
		window.addEventListener('resize', this.onResizeHandlerBinded, {passive:true});
		document.addEventListener('keydown', this.onEscapeKeyBinded);
		this.onResizeHandler();			setTimeout(()=>{
				if ( document.body.classList.contains('touch') || document.body.classList.contains('touchevents') ) {
					this.zoom.scrollTop = ( window.innerHeight - this.image.offsetHeight ) / -2;
					this.zoom.scrollLeft = ( window.innerWidth - this.image.offsetWidth ) / -2;
				}
				this.zoom.classList.add('loaded');
			}, 50);

		}

	_productZoomUnmount() {

		this.zoom.classList.remove('opened');

		setTimeout(()=>{
			window.removeEventListener('resize', this.onResizeHandlerBinded);
			window.removeEventListener('mousemove', this.onMouseMoveHandlerBinded);
			document.removeEventListener('keydown', this.onEscapeKeyBinded);
			const image = document.querySelector('#zoom img');
			image.src = '';
			image.className = '';
			image.style = '';
			this.zoom.classList.remove('loaded');
		}, 300);

	}	}

  if ( typeof customElements.get('product-image-zoom') == 'undefined' ) {
		customElements.define('product-image-zoom', ProductImageZoom);
	}

}